import type { S3Object } from '../../../drive/types';
import type { FileProgressEntry } from '../../../drive/useFileProgress';

/**
 * Creates synthetic S3 objects for files that are being uploaded but not yet in S3
 * Inserts uploading files after directories but before other files
 */
export const createUploadingObjects = (
  existingObjects: S3Object[],
  progressEntries: Map<string, FileProgressEntry>
): S3Object[] => {
  const existingKeys = new Set(existingObjects.map((obj) => obj.Key));
  const uploadingObjects: S3Object[] = [];

  progressEntries.forEach((entry) => {
    if (entry.type === 'upload' && !existingKeys.has(entry.key)) {
      uploadingObjects.push({
        Key: entry.key,
        Size: 0,
        LastModified: new Date(),
      });
    }
  });

  // Separate directories from files
  const directories = existingObjects.filter((obj) => obj.Key?.endsWith('/') || obj.isParentDirectory);
  const files = existingObjects.filter((obj) => !obj.Key?.endsWith('/') && !obj.isParentDirectory);

  // Order: directories first, then uploading files, then existing files
  return [...directories, ...uploadingObjects, ...files];
};

/**
 * Finds the file currently being processed (uploaded or downloaded)
 */
export const findActiveOperation = (
  progressEntries: Map<string, FileProgressEntry>,
  type: 'upload' | 'download'
): FileProgressEntry | undefined => {
  return Array.from(progressEntries.values()).find((entry) => entry.type === type);
};
